import PropTypes from 'prop-types';
import s from './BreedDetailInfo.module.css';

const BreedInfoDetail = ({ breed, temperament, origin, weight, life }) => {
  return (
    <div className={s.cat__info}>
      <div className={s.breed__container}>
        <div className={s.breed}>{breed}</div>
      </div>
      <div className={s.for}>Could not find brad_for in API</div>
      <div className={s.detail}>
        <div class={s.left}>
          <div className={s.label}>Temperament:</div>
          <div className={s.info}>{temperament}</div>
        </div>
        <div className={s.right}>
          <div className={s.label}>
            Origin:
            <div className={s.info}>{origin}</div>
          </div>

          <div className={s.label}>
            Weight: <div className={s.info}>{weight}</div>
          </div>

          <div className={s.label}>
            Life span: <div className={s.info}>{life}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { BreedInfoDetail };

BreedInfoDetail.propTypes = {
  breed: PropTypes.string,
  temperament: PropTypes.string,
  origin: PropTypes.string,
  weight: PropTypes.string,
  life: PropTypes.string,
};
